import React from 'react';

import { TrainingCoursesInProgressSettingsProps } from '../../types';

export const TrainingCoursesInProgressSettings: React.FC<TrainingCoursesInProgressSettingsProps> = () => {
    return <div />;
};
